export enum KeycloakRole
{
  COMPANY = 'COMPANY',
  EMPLOYEE = 'EMPLOYEE',
  REPORTS_ARCHIVAL_YEARS = 'REPORTS_ARCHIVAL_YEARS',
  REPORTS_ACTUAL_YEAR = 'REPORTS_ACTUAL_YEAR',
  WASTE_CARDS_ACCESS = 'WASTE_CARDS_ACCESS',
}
